<div class="py-20 bg-light">
  <div class="container mx-auto px-6 max-w-lg text-center">
    <div class="bg-white dark:bg-slate-800 p-8 rounded-xl shadow-lg dark:shadow-slate-900/50 border">

      <!-- Paiement réussi -->
      @if (status === 'success') {
        <div class="flex justify-center mb-4">
          <svg class="h-16 w-16 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 class="text-3xl font-bold text-secondary mb-2">Paiement Réussi !</h2>
        <p class="text-gray-600 dark:text-gray-400 mb-6">Merci pour votre abonnement. Votre plan a été mis à jour.</p>
        <a routerLink="/dashboard"
          class="bg-primary text-white font-semibold px-6 py-3 rounded-lg hover:bg-primary-hover">
          Aller au Dashboard
        </a>
      } @else {
        @if (status === 'cancel') {
          <div class="flex justify-center mb-4">
            <svg class="h-16 w-16 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 class="text-3xl font-bold text-secondary mb-2">Paiement Annulé</h2>
          <p class="text-gray-600 dark:text-gray-400 mb-6">
            Votre transaction a été annulée. Vous pouvez réessayer à tout moment depuis votre espace.
          </p>
          <a routerLink="/checkout" [queryParams]="{ plan: planId }"
            class="bg-gray-200 dark:bg-slate-700 text-secondary font-semibold px-6 py-3 rounded-lg hover:bg-gray-300 dark:hover:bg-slate-600">
            Réessayer le paiement
          </a>
        } @else {
          <p>Statut de la transaction en cours de vérification...</p>
        }
      }

      <!-- Paiement annulé -->

      <!-- Statut en cours -->

    </div>
  </div>
</div>
